/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

export default {
    red: "#db2828",
    firebrick: "#b22222",
    orange: "#f2711c",
    yellow: "#fbbd08",
    greenyellow: "#adff2f",
    olive: "#b5cc18",
    green: "#21ba45",
    darkgreen: "#006400",
    teal: "#00b5ad",
    aqua: "#00ffff",
    magenta: "#ff00ff",
    mediumpurple: "#9370db",
    blue: "#2185d0",
    skyblue: "#87ceeb",
    navy: "#000080",
    violet: "#6435c9",
    purple: "#a333c8",
    pink: "#e03997",
    lightcoral: "#f08080",
    burlywood: "#deb887",
    brown: "#a5673f",
    maroon: "#800000",
    grey: "#767676",
    black: "#1b1c1d",
    default: "#c0c0c0",
};
